import { apiInstance, legacyV2Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const reports = {
  getChart (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/report/chart`,
      params
    })
  },

  getRides (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/report/taxijobs`,
      params
    })
  },

  getCostCenters (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/report/costCenter`,
      params
    })
  },

  getEmployee (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/report/employee`,
      params
    })
  }
}

export default reports
